<template>
  <footer class="footer">
    <span>防疫專線 1922</span> | <span>口罩資訊 1919</span>
    <p>
      感謝藥師們的辛勞及所有為本次疫情付出的人們 購買口罩請多體諒藥師 🤜🤛
      一起共度疫情
    </p>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  padding: 35px 25px;
  color: #fff;
  background-color: #35495f;
  p {
    width: 260px;
    font-size: 13px;
  }
}
</style>
